import { render, staticRenderFns } from "./confirmEmailMessage.vue?vue&type=template&id=140cae64"
import script from "./confirmEmailMessage.vue?vue&type=script&lang=js"
export * from "./confirmEmailMessage.vue?vue&type=script&lang=js"
import style0 from "./confirmEmailMessage.vue?vue&type=style&index=0&id=140cae64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports